import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import config from "../../config";

import CheckoutSummary from "./CheckoutSummary";
import HtmlHelper from "./html/HtmlHelper";
import Error from "./html/Error";
import Terminal from "../../tools/payment/terminal";
import RestRequest from "../../tools/RestRequest";
import Variants from "./html/widget/Variants";
import WaitButton from "./WaitButton";
import DateDeliveryField from "./field/DateDeliveryField";
import TimeDeliveryField from "./field/TimeDeliveryField";
import OrderMap from "../OrderCheckout/OrderMap";

class Checkout extends Component {
    constructor(props) {
        super(props);

        this.modelName = 'Order';
        this.billingModelName = 'UserBilling';
        this.timerEx, this.cleanAddressTimerEx;
        this.cleanAddressTimer = 1000;

        this.state = {
            order: null,
            promocode: null,
            suggests: [],
            deliveryAddress: [],
            deliveryServices: [],
            deliveryService: "",
            excludePayments: [],
            delivery: [],
            payment: [],
            basket: [],
            errors: [],
            total: 0,
            usedBonus: 0,
            paymentId: 0,
            deliveryId: 0,
            user: null,
            finish: false,
            isButton: false,
            selectedAddress: null,
            addr: {
                index: "",
                city: "",
                street: "",
                home: "",
                room: "",
                pouch: "",
                floor: "",
            },
        };
    }

    componentDidMount() {
        this.loadDelivery();
        this.loadPayment();
        this.loadServices();
        this.loadBasket();
        this.loadUser();
    }

    loadUser() {
        if (!Number.isInteger(parseInt(this.props.userId))) return false;

        RestRequest.one(config.restUser, this.props.userId).then(data => {
            this.setState({
                user: data
            });
        });

    }

    submitForm(e) {
        e.preventDefault();
        const form = e.target;

        this.setState({isButton: true});

        RestRequest.post(config.restOrder, {
            body: new FormData(form)
        }).then(data => {
            this.setState({isButton: false});
            if (data.errors) {
                this.setState({
                    errors: data.errors
                });

                this.moveToElement(document.querySelectorAll('[aria-invalid="true"]')[0]);
            }

            let status = parseInt(data.status);

            if (status === 200) {
                if (parseInt(this.state.paymentId) === 1) {
                    this.paymentService(data.data.order.id);
                    return true;
                }

                try {
                    ym(55089223, 'reachGoal', 'create_order');
                } catch (exception) {
                }

                form.reset();
                this.setState({
                    errors: [],
                    finish: true,
                    order: data.data.order
                });

                this.moveToElement(document.querySelector('.checkout-react')[0]);
            }
        });
    }

    moveToElement(el) {
        if (!el) return false;

        el.scrollIntoView({
            behavior: 'smooth'
        });
    }

    loadDelivery() {
        RestRequest.all(config.restDelivery + '?filter[active]=1').then(data => {
            this.setState({
                delivery: data
            });
        });
    }

    loadPayment() {
        RestRequest.all(config.restPayment + '?filter[active]=1').then(data => {
            this.setState({
                payment: data
            });
        });
    }

    loadServices() {
        RestRequest.all(config.restDeliveryService + '?filter[active]=1&expand=imageUrl').then(data => {
            this.setState({
                deliveryServices: data
            });
        });
    }

    loadBasket() {
        RestRequest.all(config.restBasket).then(data => {
            if (data.status === 200 && data.items.length > 0) {
                this.setState({
                    basket: data.items
                });

                this.calcTotal();
            }
        });
    }

    calcTotal() {
        let total = 0;
        this.state.basket.map((element, key) => {
            total += parseInt(element.price) * parseInt(element.count);
        });

        if (this.state.usedBonus > 0) total -= parseInt(this.state.usedBonus);

        if (this.state.promocode !== null) total = total - Math.round(total * (this.state.promocode.discount / 100));

        if (total < 0) total = 0;

        // if (total < 500) total += 100;

        this.setState({
            total: total
        });
    }

    refreshBasket(product_id) {
        let basketItems = this.state.basket;

        basketItems.map((product, key) => {
            if (parseInt(product.id) === parseInt(product_id)) basketItems.splice(key, 1);
        });

        this.setState({
            basket: basketItems
        });

        this.calcTotal();
    }

    updateBasketItem(product_id, count) {
        let basketItems = this.state.basket;
        let basket_item;

        basketItems.map((product, key) => {
            if (parseInt(product.id) === parseInt(product_id)) {
                basketItems[key].count = count;

                basket_item = basketItems[key];
                basket_item.product_id = basketItems[key].id;
            }
        });

        let fd = new FormData();
        Object.keys(basket_item).map(key => {
            fd.append(key, basket_item[key]);
        });

        if (this.timerEx) clearTimeout(this.timerEx);
        this.timerEx = setTimeout(() => {
            RestRequest.update(config.restBasket, {
                body: fd
            }).then(data => {
            });
        }, 500);


        this.setState({
            basket: basketItems
        });

        this.calcTotal();
    }

    paymentService(order_id) {
        const terminal = new Terminal();
        terminal.registerOrder(order_id).then(data => {
            if (data.formUrl !== undefined) {
                window.location.href = data.formUrl; // by click link
            }
        });
    }

    handleSelectDeliveryService(event) {
        this.setState({deliveryService: event.target.value || ''});
    }

    handleSelectDelivery(event) {
        let current = event.target;
        let deliveryId = parseInt(current.value);

        this.setState({
            deliveryId: deliveryId
        });


        if (deliveryId === 1) {
            let tariffs_params = new FormData();
            tariffs_params.append('to', this.state.addr.index);

            this.state.basket.map(el => {
                tariffs_params.append('product_id[]', el.id);
            });

            RestRequest.post(`${config.restTariffs}`, {
                body: tariffs_params,
            }).then(data => {
            });

            this.refreshPayment([2, 3]);
        } else {
            this.refreshPayment([]);
        }
    }

    handleSelectPayment(event) {
        let current = event.target;
        this.setState({
            paymentId: current.value
        });
    }

    refreshPayment(arListPaymentId) {
        this.setState({
            excludePayments: arListPaymentId
        });
    }

    updatePoromocode(code) {
        this.setState({promocode: code});
    }

    unsetError(attribute) {
        let errors = this.state.errors;

        errors[attribute] = null;

        this.setState({errors: errors})
    }

    handleAddress(event) {
        if (this.timerEx) clearTimeout(this.timerEx);
        this.timerEx = setTimeout(() => {
            var url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
            var token = "21ebc5ed8ce5d22637d7c721b2a20621bbe00646";
            var query = event.target.value;

            var options = {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                },
                body: JSON.stringify({query: query})
            };

            fetch(url, options)
                .then(response => response.json())
                .then(result => this.setState({suggests: result.suggestions}))
                .catch(error => console.log("error", error));
        }, 1000);
    }

    handleSelectAddress(address, event) {

        let data = address.data;
        let refresh_state = {
            suggests: [],
            addr: {
                index: data.index,
                city: data.city,
                street: data.street,
                home: data.house,
                room: data.flat || null,
                pouch: null,
                floor: null,
            }
        };

        this.setState(refresh_state);
    }

    render() {

        if (this.state.finish === true) {
            return this.finish();
        }

        return this.dashboard();
    }

    onPickMap(address) {
        this.setState({selectedAddress: address});
    }

    renderAddressFields() {

        const {errors} = this.state, {deliveryAddress, suggests} = this.state;
        let error, aria_invalid, isQualityAddress = true;

        if (typeof errors === 'object' && !Array.isArray(errors)) {
            error = <Error errors={errors['address']}/>
            aria_invalid = errors['address'] !== undefined && errors['address'] !== null;
        }


        return <>
            <div className="checkout-form__title">Адрес доставки</div>

            <div className="checkout-form__group-row">
                <label className="checkout-form__label">
                    <div className="checkout-form__label-text">Адрес доставки</div>
                    <input
                        aria-invalid={aria_invalid}
                        onChange={this.handleAddress.bind(this)}
                        type="text"
                        name={this.modelName + "[address]"}
                        placeholder="Например: Барнаул, ул Попова 4 кв 211"
                        className="checkout-form__input"
                        defaultValue={this.state.selectedAddress}
                    />
                    {error}
                </label>

                <div className="checkout-form-suggs">
                    {suggests.map((el, index) => {
                        return <div className="checkout-form-suggs-item">
                            <div className="checkout-form-suggs-item__title">{el.value}</div>
                            <div className="checkout-form-suggs-item__action" onClick={this.handleSelectAddress.bind(this, el)}>Выбрать</div>
                        </div>
                    })}
                </div>

            </div>

            <div className="checkout-form__group-row">
                <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{isHiden: this.state.addr.city != null, name: "city", title: "Город", placeholder: "Город", value: this.state.addr.city}}/>
                <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{isHiden: this.state.addr.street != null, name: "street", title: "Улица", placeholder: "Улица", value: this.state.addr.street}}/>
            </div>
            <div className="checkout-form__group-row">
                <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{isHiden: this.state.addr.home != null, name: "number_home", title: "Номер дома", placeholder: "Номер дома", value: this.state.addr.home}}/>
                <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{isHiden: this.state.addr.pouch != null, name: "entrance", title: "Подъезд", placeholder: "Подъезд", value: this.state.addr.pouch}}/>
                <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{isHiden: this.state.addr.floor !== null, name: "floor_house", title: "Этаж", placeholder: "Этаж", value: this.state.addr.floor}}/>
                <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{isHiden: this.state.addr.room !== null, name: "number_appartament", title: "Квартира", placeholder: "Квартира", value: this.state.addr.room}}/>
            </div>

            <OrderMap useDefaultLocation={true} events={{
                'onClickMap': this.onPickMap.bind(this)
            }}/>
        </>;
    }

    finish() {
        const {order} = this.state;
        return <div className="checkout-success-container">
            <div className="checkout-success">
                <div className="checkout-success-header"><i className="fas fa-check-circle"/>Заказ <b>№{order.id}</b> успешно оформлен.</div>
                <div className="checkout-success-comment">В оближайшее время мы вам перезвоним</div>
                <div className="order-info">
                    <div className="order-info__row">
                        <div className="order-info__key">Время покупки</div>
                        <div className="order-info__value">{order.created}</div>
                    </div>
                    <div className="order-info__row">
                        <div className="order-info__key">Статус</div>
                        <div className="order-info__value">{order.status}</div>
                    </div>
                    <div className="order-info__row">
                        <div className="order-info__key">Сумма</div>
                        <div className="order-info__value">{order.total}</div>
                    </div>
                    <div className="order-info__row">
                        <div className="order-info__key">Доставка</div>
                        <div className="order-info__value">{order.delivery}</div>
                    </div>
                    <div className="order-info__row">
                        <div className="order-info__key">Оплата</div>
                        <div className="order-info__value">{order.payment}</div>
                    </div>
                    <div className="order-info__row">
                        <div className="order-info__key">Адрес</div>
                        <div className="order-info__value">{order.address}</div>
                    </div>
                </div>
            </div>
            <div className="checkout-success-text">
                <p>Вы можете следить за заказом из <a href="/profile/"><b>личного кабинета</b></a>. Обратите внимание, что для входа потребуется регистрация на сайте.</p>
                <p>История заказов отслеживается по номеру телефона поэтому не ошибайтесь при вводе регистрационных данных</p>
            </div>
        </div>;
    }

    renderPickDateTime() {
        return <>
            <div className="checkout-form__title">Время и дата доставки</div>
            <div className="checkout-form__group-row">
                <DateDeliveryField errors={this.state.errors}/>
                <TimeDeliveryField errors={this.state.errors}/>
            </div>
        </>;
    }

    dashboard() {
        let buttonLabel = parseInt(this.state.paymentId) === 1 ? 'Оформить заказ и оплатить' : 'Оформить заказ', deliveryService, oddInput, clientInput;

        if (parseInt(this.state.paymentId) === 2) oddInput = <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{name: "odd", title: "С какой суммы приготовить сдачу?", placeholder: "Оставьте пустым, если не нужна сдача"}}/>


        return (
            <div className="page__group-row">
                <div className="page__left">
                    <form className="checkout-form" onSubmit={this.submitForm.bind(this)}>
                        <div className="checkout-form__title">Укажите способ доставки</div>

                        <Variants errors={this.state.errors} unsetError={this.unsetError.bind(this)} modelName={this.modelName} attribute="delivery_id" handlerSelect={this.handleSelectDelivery.bind(this)} models={this.state.delivery}/>

                        {deliveryService}

                        {parseInt(this.state.deliveryId) === 2 ? this.renderPickDateTime() : ''}

                        <div className="checkout-form__title">Укажите ваши данные</div>
                        <div className="checkout-form__group-row">
                            <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{name: "phone", title: "Ваш номер телефона*", placeholder: "Ваш номер телефона*", class: 'js-mask-ru'}}/>
                            <HtmlHelper errors={this.state.errors} unsetError={this.unsetError.bind(this)} element="input" modelName={this.modelName} options={{name: "email", title: "Ваш электронный адрес*", placeholder: "Ваш электронный адрес*"}}/>
                        </div>

                        {parseInt(this.state.deliveryId) !== 3 && parseInt(this.state.deliveryId) > 0 ? this.renderAddressFields() : ''}


                        <label className="checkout-form__label" htmlFor="checkout-comment">
                            <HtmlHelper errors={this.state.errors} element="textarea" modelName={this.modelName} options={{name: "comment", title: "Комментарий к заказу", placeholder: "Ваши пожелания"}}/>
                        </label>

                        {clientInput}

                        <div className="checkout-form__title">Укажите способ оплаты</div>
                        <Variants unsetError={this.unsetError.bind(this)} errors={this.state.errors} modelName={this.modelName} attribute="payment_id" handlerSelect={this.handleSelectPayment.bind(this)} models={this.state.payment.filter(element => !this.state.excludePayments.includes(element.id))}/>

                        {/*Здесь поле про наличные*/}
                        {oddInput}

                        {/*<div className="checkout-form__title">Промокод и бонусы</div>*/}
                        {/*<div className="checkout-form__group-row">*/}
                        {/*    <PromocodeField promocode={this.state.promocode} updatePoromocode={this.updatePoromocode.bind(this)} refreshBasket={this.refreshBasket.bind(this)}/>*/}
                        {/*    {this.state.user !== null ? <UserBonusField usedBonus={this.state.usedBonus} refreshBasket={this.refreshBasket.bind(this)} updateUsedBonus={(value) => this.setState({usedBonus: value})} accountId={this.state.user.phone}/> : <CheckoutUserBonusAuth/>}*/}
                        {/*</div>*/}

                        <div className="checkout-form__group-row" style={{alignItems: "center"}}>
                            {/*<button type="submit" className="add-basket checkout-form__submit">{buttonLabel}</button>*/}
                            <WaitButton active={this.state.isButton} label={buttonLabel}/>
                            <p className="checkout-agree-text">
                                Нажимая на кнопку «Оформить заказ», вы принимаете условия <a href="/about/agree/">Согласия на обработку персональных данных</a>
                            </p>
                        </div>

                    </form>
                </div>
                <div className="page__right">
                    <CheckoutSummary refreshBasket={this.refreshBasket.bind(this)} updateBasketItem={this.updateBasketItem.bind(this)} total={this.state.total} basket={this.state.basket}/>
                </div>
            </div>
        )
    }
}


const checkout = document.querySelector('.checkout-react');

if (checkout) {

    const userId = checkout.getAttribute('data-user');

    ReactDOM.render(<Checkout userId={userId}/>, checkout);
}
